/**
 * Extracts the core transaction ID from a counterparty activity composite key.
 * Activity ID format: `crbId#bankId#state#transactionId`
 */
export function getTransactionIdFromActivityId(activityId: string): string {
  return activityId.split('#')[3] ?? '';
}
